import { Suspense, forwardRef, lazy } from 'react';

import type HCaptchaInstance from '@hcaptcha/react-hcaptcha';

type HCaptchaProps = HCaptchaInstance['props'];

// Loaded lazily so the hCaptcha script/widget only fetches once a form actually renders it,
// instead of shipping in every page's initial bundle.
// Uses an explicit forwardRef around React.lazy (rather than next/dynamic, whose internal
// Loadable wrapper isn't itself a forwardRef component) so captchaRef.current reliably points
// at the real HCaptcha instance once it mounts.
const HCaptcha = lazy(() => import('@hcaptcha/react-hcaptcha'));

export const LazyHCaptcha = forwardRef<HCaptchaInstance, HCaptchaProps>((props, ref) => (
  <Suspense fallback={null}>
    <HCaptcha {...props} ref={ref} />
  </Suspense>
));
LazyHCaptcha.displayName = 'LazyHCaptcha';
